export default {
    sourceUpdated: 'Your source has been updated.',
    sourceUpdateFailed: "We couldn't update this source. Check that it is still connected, then try again.",
    publishUnavailable: "Publishing isn't available right now. Please contact MarketScale support for help.",
    reviewRequiredFields: 'Please fill in the required fields before continuing.',
    requestUnavailable: "We couldn't open this request. Please reopen the invitation link or ask the sender for a new one.",
    mediaPreparing: 'Preparing your media',
    mediaMotionVideo: 'Making your video play beautifully.',
    mediaMotionImage: 'Bringing your image into view.',
    mediaMotionMp4: 'Creating an MP4 preview for playback in Studio.',
    mediaMotionWebp: 'Creating a WebP preview your browser can display.',
    mediaMotionExisting: 'Getting your {format} preview ready to open.',
    mediaMotionGeneric: 'Getting your media ready to open in Studio.',
    mediaMotionSource: 'Source',
    mediaMotionPreview: 'Preview',
    mediaMotionMedia: 'Media',
    mediaMotionOutput: 'Studio preview',
    mediaMotionAutomatic: 'This preview updates automatically.',
    mediaMotionPause: 'Pause animation',
    mediaMotionResume: 'Resume animation',
    mediaMotionSlow: 'Taking a little longer',
    mediaProgress: {
        label: 'Conversion progress',
        reported: '{percent}% · reported by the media processor',
        noPercentage: 'No percentage yet',
        waiting: 'Waiting for a progress update',
        queued: 'Queued for conversion',
        reading: 'Reading your file',
        processing: 'Processing your file',
        converting: 'Converting your preview',
        saving: 'Saving your preview',
        finalizing: 'Conversion finished · preparing playback',
        ready: 'Ready to play',
        failed: 'Processing could not finish',
        unavailable: 'Progress update unavailable',
    },
    mediaPreparingSlow: 'Large files can take longer. You can try processing this file again.',
    mediaRetry: 'Try again',
    mediaRetrySending: 'Requesting another attempt…',
    mediaRetryAccepted: 'Your media will be processed again. Check back here for updates.',
    mediaRetryFailed: "We couldn't restart processing. Please try again. If it keeps happening, contact support.",
    // SM-10178: the conversion died; shown in place of the preparing animation.
    mediaFailedTitle: 'This file could not be processed',
    mediaFailedGeneric: "Studio couldn't create a playable version of this file.",
    mediaFailedReasonLabel: 'What the media processor reported',
    mediaFailedHelpReconvert: 'Reconvert to try again. If it fails the same way, the file itself may be damaged; upload a new copy.',
    mediaFailedHelp: 'Upload a new copy of the file, or ask a channel admin to reconvert it.',
    mediaReconvert: 'Reconvert',
    mediaReconvertSending: 'Reconverting…',
    // B
    badRequest: "We couldn't complete that. Please check your details and try again.",

    // F
    fileIsTooLarge: 'File is too large. Please try uploading a smaller file.',
    forbidden: "You don't have access to this. Ask your channel admin for help.",

    // I
    invalidEmail: 'Invalid email address: Please enter a valid email address.',

    // N
    notFound: "We couldn't find this item. It may have been moved or deleted.",
    networkError: 'Connection interrupted',
    networkErrorDescription: 'A network issue has occurred. Please check your Internet connection and try again.',

    // O
    oopsSomethingWentWrong: "We couldn't complete that. Please try again. If it keeps happening, contact support.",

    // S
    serverError: "Something went wrong on our side. Please try again in a moment.",
    serviceUnavailable: "This feature is temporarily unavailable. Please try again in a few minutes.",
    sessionExpired: 'We need to refresh your connection. This page will reload automatically.',
    // somethingWentWrong: 'Something went wrong.',

    // U
    unauthorized: 'Please sign in again to continue.',

    // Y
    // yourFileIsTooLarge: 'The uploaded file is too large. Please try again with a smaller file.',
    // yourFileTypeIsUnsupported: 'The uploaded file type is unsupported. Please convert it to a supported format and try again.'
};
